import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { checkoutShippingCarrierServiceStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.carrierSelect = mergeToNew(checkoutShippingCarrierServiceStyles.carrierSelect, {
    css: css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
});

checkoutShippingCarrierServiceStyles.serviceSelect = mergeToNew(checkoutShippingCarrierServiceStyles.serviceSelect, {
    css: css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
});
